<template>
	<div>
	   <el-row style="height:80px;position:fixed;top: 0;z-index:999;">
	     <el-col :span="16">
			 <div class="navlist">
				  <div style="display:flex;align-items: center;">
				    <img :src="logo" alt="" sizes="" srcset="" style="width:40px;height:40px;margin-right:10px;" />
				    <h2>
					   {{site_title}}
					</h2>
				  </div>
				   <router-link to="/demandHome/demandIndex" active-class="active-link">首页</router-link>
				   <router-link to="/demandHome/demandOrder" active-class="active-link">我的订单</router-link>
				   <router-link to="/demandHome/demandinvitedList"  active-class="active-link">邀标记录</router-link>
				   <el-dropdown @command="handleDropdownCommand">
						<span class="nav-item" :class="{ 'active-link': isPersonalCenterActive }">
							个人中心<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="/demandHome/demandPromotion">
								<span :class="{ 'active-link': isPathActive('/demandHome/demandPromotion') }">我的推荐</span>
							</el-dropdown-item>
							<el-dropdown-item command="/demandHome/demandinvoiceList">
								<span :class="{ 'active-link': isPathActive('/demandHome/demandinvoiceList') }">历史开票</span>
							</el-dropdown-item>
							<el-dropdown-item command="/demandHome/demandUserInfo">
								<span :class="{ 'active-link': isPathActive('/demandHome/demandUserInfo') }">个人信息</span>
							</el-dropdown-item>
							<el-dropdown-item command="/demandHome/demandFeedback">
								<span :class="{ 'active-link': isPathActive('/demandHome/demandFeedback') }">意见反馈</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
			 </div>  
		</el-col>
	    <el-col :span="4" style="display:flex;">
			 <el-button type="primary" icon='el-icon-plus' round @click="xuqiu">发布需求</el-button>
			 <div class="disng">
				<div style="position:relative;">
					<img src="@/assets/lingdan.png" alt="" sizes="" srcset=""   class="disng1" @click="message"/>
					<span v-if="userinfo.unread_count>0" class="xiaoxi" style=""></span>
				</div>
				
				<img :src="(userinfo && userinfo.avatar) || ''" alt="" sizes="" srcset=""   class="disng2" @click="getuser"/>
			 </div>
		</el-col>
	   </el-row>
	   <div style="height:80px;"></div>
	   <el-dialog
	     title="发布需求"
	     :visible.sync="centerDialogVisible"
	   	 :close-on-click-modal="false"
	     width="810px">
	     <div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			  <el-form-item label="需求标题" prop="name">
			    <el-input v-model="ruleForm.name"></el-input>
			  </el-form-item>
			  <el-form-item label="选择行业" prop="value">
			    <el-select v-model="ruleForm.value"   
				           multiple
	                       :multiple-limit="5" 
						   placeholder="请选择行业，最多选择五个" style="width:100%;">
			       <el-option :label="i.name" :value="i.dict_value" v-for="(i,index) in industry" :key="index"></el-option>
			    </el-select>
			  </el-form-item>
			  <el-form-item label="详细描述" prop="description">
			    <el-input type="textarea" v-model="ruleForm.description"></el-input>
			  </el-form-item>
			  <el-form-item label="报价截止时间">
			    <el-col :span="24">
			      <el-form-item prop="end_time">
					 <el-date-picker
					     v-model="ruleForm.end_time"
						  style="width: 100%;"
					      type="datetime"
					      placeholder="选择日期时间">
					    </el-date-picker>
			      </el-form-item>
				  <p style="color: #FF0000;font-size:12px;">如您未设置时间，报价将会<span>{{demand_off_time || '24'}}</span>时后自动截止并关闭需求</p>
			    </el-col>
			  </el-form-item>
			  <el-form-item label="附件上传" v-if="demand_file_config==1">
				   <el-upload
				     class="upload-demo"
				     :action="uploadActionUrl"
				     :on-remove="handleRemove"
				     :on-success="handleUploadSuccess"
				     :before-remove="beforeRemove"
				     :multiple='false'
				     :limit="4"
				     :on-exceed="handleExceed"
				     :file-list="fileList">
					 <div>
						<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
						<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
							 单个文件最大支持10M，最多不超过四个文件，仅支持png，jpg，pdf，zip文件类型
						</span>
					 </div>
				   </el-upload>
			  </el-form-item>
			</el-form>
			<div>
				<p style="width:100%;text-align:center;color: #FF0000;font-size:12px;">发布需求后需要平台审核，自动过审时间为{{demand_auto_pass || '24'}}小时</p>
				<div class="fbfooter">
					 <div class="fbfooter1" @click="quxiao">取消</div> 
					 <div class="fbfooter2" @click="submitForm('ruleForm')">立即发布</div>
				</div>
			</div>
		 </div>
	   </el-dialog>
	   <router-view></router-view>
	   <!-- :close-on-click-modal="false" -->
	</div>
</template>

<script>
	import { mapState } from 'vuex'
    import config from '@/config/index'
	import { personal,BaseGetConfig,dictValue,DemandAdd,Demandupdate} from '@/api/api'
	
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		  baseURL:config.baseURL,
		  centerDialogVisible:false,
		  ruleForm: {
			value:"",
			i_ids:"",
			name: '',
			description:"",
			end_time:"",
			file:[]
		  },
		  fileList:[],
		  rules: {
			name: [
			  { required: true, message: '请输入需求标题', trigger: 'blur' },
			],
			value: [
			  { required: true, message: '请选择行业', trigger: 'blur' }
			],
			description: [
			  { required: true, message: '请填写需求详情', trigger: 'blur' }
			]
		  },
		  demand_file_config:"",
		  demand_off_time:"",
		  industry:"",
		  demand_auto_pass:"",
		  site_title:"",
		  logo:"",
		  unread_count:false
	    }
	  },
	   watch:{
	  		  centerDialogVisible:{
	  			  handler(newValue,oldValue){
	  				  if(newValue==false){
	  					    this.ruleForm.value=""
	  					    this.ruleForm.i_ids=""
							this.ruleForm.name=""
							this.ruleForm.description=""
							this.ruleForm.end_time=""
	  					    this.ruleForm.file=[]
							this.fileList=[]
	  					  }
	  				  },
	  				 deep:true
	  			}
	  	  },
	  computed: {
		  ...mapState({
		  	userinfo: (state) => state.userInfo || {}
		  }),
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion|demandFeedback)(\/|$)/.test(p)
	  		},
			// 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
			uploadActionUrl() {
				const base = this.baseURL || ''
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			}
	  },
	  created() {
	  	 this.getpersonal()
		 this.getBaseGetConfig()
		 this.getdictValue()
		 this.logo=localStorage.getItem("login")
		 this.site_title=localStorage.getItem("site_title")
	  },
	  methods: {
		  
		  quxiao(){
			 this.centerDialogVisible=false 
		  },
		routeuser(){
			if (this.$route.path !== '/demandHome/demandUserInfo') {
			    this.$router.push('/demandHome/demandUserInfo')
			}
		},
		handleExceed(files, fileList) {
		  this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		},
		getUploadUrlFromResponse(response) {
		  if (!response) return ''
		  if (typeof response === 'string') return response
		  const level1 = response.data || {}
		  const level2 = level1.data || {}
		  const candidate =
			level2.url ||
			level2.file ||
			level1.url ||
			level1.file ||
			response.url ||
			response.file ||
			''
		  if (Array.isArray(candidate)) return candidate[0] || ''
		  if (typeof candidate === 'string') return candidate
		  if (Array.isArray(level1)) return level1[0] || ''
		  if (typeof level1 === 'string') return level1
		  return ''
		},
		handleUploadSuccess(response, file, fileList) {
		  this.fileList = fileList
		  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
		  if (uploadedUrl) {
			const exists = this.ruleForm.file.includes(uploadedUrl)
			if (!exists) this.ruleForm.file.push(uploadedUrl)
		  }
		},
		beforeRemove(file, fileList) {
		  return this.$confirm(`确定移除 ${file.name}？`)
		},
		handleRemove(file, fileList) {
		  this.fileList = fileList
		  const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		  if (!removedUrl) return
		  this.ruleForm.file = this.ruleForm.file.filter((url) => url !== removedUrl)
		},
		getdictValue(){
		  	dictValue({
		  		key:"industry"
		  	}).then(res=>{
		  		this.industry=res.data.data.industry
		  		// this.work_year.forEach(item =>{
		  		// 	item.text=item.name
		  		// })
		  	})
		},
		getBaseGetConfig(){
		  	BaseGetConfig({
		  		key:"demand_file_config,demand_off_time,demand_auto_pass"
		  	}).then(res=>{
		  		this.demand_file_config=res.data.data.demand_file_config
		  		this.demand_off_time=res.data.data.demand_off_time
				this.demand_auto_pass=res.data.data.demand_auto_pass
		  	})
		},
		getpersonal(){
			// personal({}).then(res=>{
			// 	this.userinfo=res.data.data
			// 	this.unread_count=this.userinfo.unread_count
			// 	localStorage.setItem("userinfo",this.userinfo)
			// })
		},
	    xuqiu(){
			 this.centerDialogVisible=true
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			    // this.DemandAdd(this.ruleForm)
				this.setDemandAdd()
			  } else {
			    console.log('error submit!!')
			    return false
			  }
			})
		},
		setDemandAdd(){
			this.ruleForm.file=[]
			console.log(this.fileList)
			if(this.fileList.length>0){
				this.fileList.forEach(res=>{
					this.ruleForm.file.push(res.response.data)
				})
			}
			this.ruleForm.i_ids=this.ruleForm.value.join()
			DemandAdd({
				...this.ruleForm
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('提交成功');
					this.centerDialogVisible=false
					// 通知需求列表页刷新
					this.$root.$emit('refreshDemandIndex')
			
				}else{
					// this.$message.error(res.data.msg);
				}
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		message(){
			if (this.$route.path !== '/demandHome/messagelist') {
			    this.$router.push('/demandHome/messagelist')
			}
		},
		getuser(){
			if (this.$route.path !== '/demandHome/demandUserInfo') {
			    this.$router.push('/demandHome/demandUserInfo')
			}
		},
		handleDropdownCommand(command) {
			if (command && this.$route.path !== command) {
				this.$router.push(command)
			}
		},
		isPathActive(path) {
			if (!path) return false
			return this.$route && this.$route.path ? this.$route.path === path : false
		}
	  },
	}
</script>

<style scoped>
	.el-row {
		width:100%;
		background-color:#fff;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.xiaoxi{
		position:absolute;
		right:0;top:0px;width:10px;height:10px;display: block;background-color: #FF0000;border-radius:50%;
	}
	.active-link{
		color:#1E3A8A ;
	}
	.navlist{
		display:flex;
		align-items: center;
	}
	.navlist a{
		font-weight: bold;
		font-size: 20px;
		margin-left:72px;
		color:#999999;
	}
	.nav-item {
	  font-weight: bold;
	  font-size: 20px;
	  margin-left: 72px;
	  cursor: pointer;
	  display: inline-flex;
	  align-items: center;
	}
	
	.nav-item .el-icon-arrow-down {
	  font-size: 14px;
	  margin-left: 4px;
	}
	::v-deep .el-dropdown{
		color:#999999;
	}
	::v-deep .active-link{
	    color: #1E3A8A !important;
	}
	::v-deep .el-dialog__body {
	    padding: 0px 20px 20px;
	}
	::v-deep .el-dialog{
		border-radius:6px !important;
	}
	.fbfooter{
		display:flex;
		justify-content:center;
		align-items: center;
	}
	.fbfooter div{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px 8px 8px 8px;
		display:flex;
		align-items:center;
		justify-content:center;
		margin:20px;
		cursor:pointer;
		color:#1E3A8A;
	}
	.fbfooter2{
		background: #1E3A8A !important;
		color:#fff !important;
	}
	.disng{
		display:flex;
		align-items: center;
	}
	.disng1{
		width:24px;
		height:24px;
		margin-left:24px;
		cursor:pointer;
	}
	.disng2{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-left:24px;
		cursor:pointer;
	}
</style>